<template>
  <div class="hidden-sm-and-up">
<!--    <div class="mobile_callme_wrap">-->
<!--      <p>-->
<!--        Copyright ©2020 云逸创造 . All Rights Reserved .-->
<!--        浙ICP备15031491号-1浙公网安备 33010802005636号-->
<!--      </p>-->
<!--    </div>-->
    <div class="navigate_wrap">
      <!-- <span>友情链接:</span> -->
      <div class="line1"><span>Copyright ©2025 河南良悦信息科技有限公司版权所有</span></div>
      <div class="line2"><span>豫ICP备2022018655号-1</span></div>
      <!-- <a href="http://www.cena.com.cn/">中国电子信息产业</a>
      <a href="http://www.ccidmedia.com/">赛迪传媒</a>
      <a href="http://www.cio360.net/">中国信息主管网</a>
      <a href="http://www.ccidcom.com/">通信产业网</a>
      <a href="#">赛迪呼叫</a>
      <a href="http://www.mtx.cn/">赛迪顾问</a>
      <a href="http://www.cciddata.com/">赛迪数据在线</a>
      <a href="http://www.cstc.org.cn/">中国软件评测中心</a>
      <a href="http://www.ccidit.com/">赛迪时代</a>
      <a href="http://www.chinaeinet.com/">中国工业和信息化</a>
      <a href="http://www.saism.com.cn/">软件和集成电胳</a>
      <a href="http://www.ccidreport.com/">中市场情报中心</a>
      <a href="http://www.mtx.cn">满天星·产业通</a>
      <a href="http://www.ccidti.com/">赛迪科创</a>
      <a href="https://wjt.ccidit.com/Sy/">赛迪问卷通</a>
      <a href="https://www.yaoxuanzhi.com/">药选址</a>
      <a href="http://www.cpupps.cn/">药学进展</a>
      <a href="http://www.biotechchina.org/">中国生物工程学会</a>
      <a href="http://www.zchsp.com/">浙江省健康服务业促进会</a>
      <a href="https://www.biodiscover.com/">生物探索</a>
      <a href="https://med.sina.com/">新浪医药</a> -->
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.navigate_wrap {
  width: 100%;
  margin: 0 auto;
  padding: 10PX 0;
  background-color: #F5F7FA;
  // word-break: keep-all;
  // word-wrap: break-word;
  display: flex;
  flex-wrap: wrap;
  .line1{
    text-align: center;width: 100%
  }
  .line2{
    text-align: center;width: 100%;margin-top: 10px
  }
  a {
    color: hsla(0, 0%, 100%, 0.5);
    font-size: 0.8rem;
    margin-right: 33px;
    text-decoration: none;
  }
  span {
    color: #8491AB;
    padding-right: 20px;
    font-size: 0.8rem;
    margin-right: 0;
  }
  p {
    font-size: 16PX;
    color: #4e5557;
  }
}
</style>